<ng-container #content>
  <div class="confirm-send-business-card-modal">
    <div class="confirm-send-business-card-modal-wrapper">
      <button mat-icon-button mat-dialog-close class="close-button">
        <mat-icon>close</mat-icon>
      </button>
      <div class="confirm-send-business-card-modal-content">
        <bau365-shell-logo-dark class="confirm-send-business-card-modal-logo"></bau365-shell-logo-dark>
        <h4 class="confirm-send-business-card-modal-header mat-headline-4">
          @if (origin === 'firstTime') {
          <ng-container i18n="@@uiModals-confirmSendBusinessCard-firstTime-headline">
            Sie haben Fragen oder benötigen weitere Informationen?
          </ng-container>
          } @else {
          <ng-container i18n="@@uiModals-confirmSendBusinessCard-headline">
            Digitale Visitenkarte jetzt senden?
          </ng-container>
          }
        </h4>
        <ul>
          <li i18n="@@uiModals-confirmSendBusinessCard-list-item-1">Digitale Visitenkarte übermitteln</li>
          @if (isBauInsights) {
          <li i18n="@@uiModals-confirmSendBusinessCard-list-item-2-insights">Vom Unternehmen kontaktiert werden</li>
          } @else {
          <li i18n="@@uiModals-confirmSendBusinessCard-list-item-2">Vom Aussteller kontaktiert werden</li>
          }
        </ul>
      </div>
    </div>
    <div class="confirm-send-business-card-modal-actions">
      <div class="confirm-send-business-card-modal-actions__cancel">
        <button
          mat-flat-button
          mat-dialog-close
          color="secondary"
          class="confirm-send-business-card-modal-actions__cancel-button">
          Abbrechen
        </button>
      </div>
      <div class="confirm-send-business-card-modal-actions__confirm">
        <button
          mat-flat-button
          color="primary"
          class="confirm-send-business-card-modal-actions__confirm-button"
          i18n="@@uiModals-confirmSendBusinessCard-confirmLinkLabel"
          (click)="onSendBusinessCard()">
          Visitenkarte senden
        </button>
      </div>
    </div>
  </div>
</ng-container>
